import { formatDate } from '@/helpers/formatDate';
import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';

export const TopPosts = ({ data }) => {
  return (
    <Wrapper>
      <p>Top posts</p>
      <List>
        {data.map((post) => (
          <Item key={post.id}>
            <Link href={`/blog/${post.slug}`}>
              <Info>
                <PostDate>{formatDate(post.created_at)}</PostDate>
                <PostDate>{post.time_to_read || '1'} min reading</PostDate>
              </Info>
              <PostTitle>{post.title}</PostTitle>
            </Link>
          </Item>
        ))}
      </List>
    </Wrapper>
  );
};

const Wrapper = styled.ul`
  text-align: left;
  border: 1px solid rgba(219, 224, 239, 1);
  padding: 24px;
  border-radius: 10px;

  & > p {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 24px;
  }
`;

const Info = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #888;
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Item = styled.li`
  /* font-size: 16px; */
`;

const PostTitle = styled.p`
  margin: 0;
`;

const PostDate = styled.span``;
